import service from '@saturn/service';
import { RemoteStorage } from 'src/utils/RemoteStorage';

export const fetchImagesV3Data = service.get<ImageV3API.Data>(
  '/easylive/image/my/image/list'
);
export const imagesV3Data = new RemoteStorage(fetchImagesV3Data);

export const fetchImagesV3Shop = service.get<ImageV3API.Image[]>(
  '/easylive/image/other/image/list'
);
export const imagesV3Shop = new RemoteStorage(fetchImagesV3Shop);

export const fetchNumberRankData = service.get<ImageV3API.NumberRankData>(
  '/easylive/image/rank'
);
export const numberRankStorage = new RemoteStorage(fetchNumberRankData);

export const fetchFightingRankData = service.get<ImageV3API.FightingRankData>(
  '/easylive/image/fight/rank'
);
export const fightingRankStorage = new RemoteStorage(fetchFightingRankData);

export const fetchHistory = service.get<ImageV3API.HistoryData, any>(
  '/easylive/image/record/list'
);

export const setDefaultImage = service.post<any, ImageV3API.ImageControlParams>(
  '/easylive/image/setDefault'
);

export const cancelDefaultImage = service.post<
  any,
  ImageV3API.ImageControlParams
>('/easylive/image/cancel/default');

export const resolveImage = service.post<any, ImageV3API.ImageControlParams>(
  '/easylive/image/resolved'
);

export const exchangeImage = service.post<any, ImageV3API.ImageControlParams>(
  '/easylive/image/exchange'
);

export const evolveImage = service.post<
  ImageV3API.EvolutionResult,
  ImageV3API.EvolutionParams
>('/easylive/image/advance');

export const presentProp = service.post<any, ImageV3API.PresentParams>(
  '/easylive/image/send'
);

export const upgradeStar = service.post<any, ImageV3API.ImageControlParams>(
  '/easylive/image/upgrade/star'
);

export const polishPieces = service.post<any, ImageV3API.PolishParams>(
  '/easylive/image/polish/pieces'
);

export const resetAbility = service.post<any, ImageV3API.ResetAbilityParams>(
  '/easylive/image/reset/talent'
);

export const composeImage = service.post<any, ImageV3API.MaterialControlParams>(
  '/easylive/image/compose'
);

export const resetAttribute = service.post<any, ImageV3API.ImageControlParams>(
  '/easylive/image/reset/attribute'
);
export const resetDebuff = service.post<any, ImageV3API.ImageControlParams>(
  '/easylive/image/purify'
);
export const transformPiece = service.post<any, ImageV3API.TransformParams>(
  '/easylive/image/change'
);
export const fetchFightInfo = service.get<ImageV3API.FightInfo, any>(
  '/easylive/image/fight/info'
);
export const fetchAbilityList = service.get<ImageV3API.Ability[]>(
  '/easylive/image/talent/list'
);
export const inspireImage = service.post<any, ImageV3API.ImageControlParams>(
  '/easylive/image/inspire'
);
export const startFight = service.post<any, any>('/easylive/image/fight');
export const composeJewel = service.post<any, ImageV3API.JewelComposeParams>(
  '/easylive/image/stone/compose'
);
